import { CampaignTypeServiceMap, Rights } from './constant';

export const hasAnyRights = (user, rights) => {
	const accessLevel = user?.accessLevel;
	const hasAnyRight = rights.some((right) => {
		return Rights[right] && Rights[right].includes(accessLevel);
	});
	return hasAnyRight;
};

export const hasRights = (user, rights) => {
	const accessLevel = user?.accessLevel;
	const hasRight = rights.every((right) => {
		return Rights[right] && Rights[right].includes(accessLevel);
	});
	return hasRight;
};

export const isSuperAdmin = (user) => {
	return user?.accessLevel === 0;
};

export const isCentralUser = (user) => {
	return user?.accessLevel === 1;
};

export const isAdminUser = (user) => {
	return user?.accessLevel === 1;
};

export const isMSSPAdmin = (user) => {
	return user?.accessLevel === 2;
};

export const isEndUser = (user) => {
	return user?.accessLevel ===3;
};

export const isReadOnly = (user) => {
	return user?.accessLevel === 4;
};

// Named composites for the "is this user platform staff" checks that were
// previously re-assembled ad hoc (OR-ing 2-3 role checks together) per call
// site — factored out so a future staff-like role only needs updating here,
// not hunted down across every view that gates on one of these groups.
export const isPlatformStaff = (user) => isSuperAdmin(user) || isAdminUser(user);
export const isCentralOrMsspStaff = (user) => isSuperAdmin(user) || isAdminUser(user) || isMSSPAdmin(user);

/**
 * Whether AI features (chatbot, insights, content generation) should be visible.
 * Access is governed by the tenant's `aiFeaturesEnabled` flag, set on customer
 * create/edit. Platform staff (super/central admin) always see AI; read-only
 * users never see it, regardless of the tenant's flag; every other tenant user
 * sees it only when their organisation has AI enabled. Falls back to the legacy
 * `allowchatBot` flag until existing customer docs are migrated.
 */
export const isAiEnabled = (user, currentCustomer) => {
	const level = user?.accessLevel;
	if (level === 0 || level === 1) return true;
	if (level === 4) return false;
	return !!(currentCustomer?.aiFeaturesEnabled ?? currentCustomer?.allowchatBot);
};

export const hasServiceRights = (service, client) => {
	if (!client || !client.services) {
		return false;
	}
	return CampaignTypeServiceMap[service].every((serviceName) => {
		return client.services.indexOf(serviceName) >= 0;
	});
};
